import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledWrapper,
  StyledItemNoBorder,
  StyledSpan,
  StyledIconNav
} from './style';
import { Download } from '../../../../assets/images';

const GeneralItem = ({ className, text, onClick, id }) => (
  <StyledItemNoBorder className={className}>
    <StyledSpan className="GeneralItem-text">{text}</StyledSpan>{' '}
    <StyledWrapper onClick={onClick}>
      <StyledIconNav
        svg={Download}
        size="s"
        color="dark"
        hover
        id={`${id}Internal`}
      />
    </StyledWrapper>
  </StyledItemNoBorder>
);

GeneralItem.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};

export default GeneralItem;
